import React from 'react';

import * as S from './styles';

interface IVerticalLineWithArrows {
  arrowUp?: boolean;
  arrowDown?: boolean;
}

function VerticalLineWithArrows({
  arrowUp = false,
  arrowDown = false,
}: IVerticalLineWithArrows) {
  return (
    <S.VerticalLine>
      {arrowUp && (
        <S.ArrowUp />
      )}
      <S.Line />
      {arrowDown && (
        <S.ArrowDown />
      )}
    </S.VerticalLine>
  );
}

export default VerticalLineWithArrows;
